import React, { useState } from 'react';

const AgendaModal = ({ onClose, onConfirm }) => {
  const [date, setDate] = useState('');
  const [time, setTime] = useState('');

  const handleSubmit = () => {
    const [hours, minutes] = time.split(':').map(Number);
    const start = new Date(date);
    start.setHours(hours);
    start.setMinutes(minutes);
    const end = new Date(start);
    end.setHours(end.getHours() + 2); // example: 2-hour hike
    onConfirm({ start, end });
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center">
      <div className="bg-white p-6 rounded shadow-md w-[300px]">
        <h2 className="text-xl font-semibold mb-4">Set Your Event</h2>
        <input type="date" value={date} onChange={(e) => setDate(e.target.value)} className="mb-3 w-full border p-2" />
        <input type="time" value={time} onChange={(e) => setTime(e.target.value)} className="mb-3 w-full border p-2" />
<div className="flex justify-between">
  <button onClick={onClose} className="bg-gray-300 px-4 py-2 rounded">Cancel</button>
  <button onClick={handleSubmit} className="bg-green-500 text-white px-4 py-2 rounded">Confirm</button>
</div>
      </div>
    </div>
  );
};

export default AgendaModal;
